import { render, staticRenderFns } from "./htDialogBtn.vue?vue&type=template&id=3af9807a&scoped=true&"
import script from "./htDialogBtn.vue?vue&type=script&lang=js&"
export * from "./htDialogBtn.vue?vue&type=script&lang=js&"
import style0 from "./htDialogBtn.vue?vue&type=style&index=0&id=3af9807a&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3af9807a",
  null
  
)

export default component.exports